import CircularProgress from "@mui/material/CircularProgress";
import closeIcon from "assets/icons/close.svg";
import { InputField } from 'components';
import Button from "components/button/Button";
import React from 'react';
import "./confirmSaveTemplateModal.scss";
import { fontConfig } from "theme/fontConfig";

const ConfirmSaveTemplateModal = ({
  formik,
  field,
  closeModal,
  createTemplate,
  saveTemplate,
  saveTemplateLoading,
  enableEdit,
  previewTemplete,
}) => {
  const buttons = [
    {
      id: "cancel",
      label: "Cancel",
      action: () => {
        createTemplate();
        closeModal()
      },
      className: "create-letter__actions-btn cancel",
      variant: "primary-outline",
    },
    {
      id: "save",
      label:enableEdit || previewTemplete? "Save": "Save as a template",
      action: () => {
        saveTemplate();
      },
      className: "create-letter__actions-btn submit",
      disabled: enableEdit || previewTemplete? false:!formik?.values?.templateName?.trim(),
      loading:saveTemplateLoading,
      variant: "primary",
    },
  ];


  return (
    <div className="confirm-save-template-modal">
        <div className="confirm-save-template-modal-close"
          onClick={closeModal}
        >
          <img src={closeIcon} alt="" />
        </div>
      <div className="confirm-save-template-modal__wrapper">
        <h3
          className="confirm-save-template-modal-title"
        >
        {enableEdit || previewTemplete ?"Do you want to update it as a template?" :"Do you want to save it as a template?"}
        </h3>
        {!enableEdit && !previewTemplete &&   <div className="confirm-save-template-modal-field">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Template Name',
              name: 'templateName',
              placeholder: 'Enter Template Name',
              checkValidation: true,
            }}
            value={formik.values?.[field]}
            handleChange={(e) => {
              formik.setFieldValue(field, e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.[field] === '') {
                e.preventDefault();
              }
            }}
            maxLength={30}
            style={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #E0E0E0",
            }}
          />
        </div> }
     
        <div className="confirm-save-template-modal__actions">
          {buttons.map((button) => (
            <Button
              className={button.className}
              variant={button.variant}
              key={button.id}
              onClick={button.action}
              disabled={button.disabled}
              size="md"
            >
              {button.loading ? (
                <div className="d-flex">
                  <CircularProgress
                    size={22}
                    style={{
                      color: "#ffffff",
                    }}
                  />
                </div>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ConfirmSaveTemplateModal